import type { PatientWithAppointmentApi } from "@/Modules/Models/Api/Schedule";

import { get2 } from "./utils/FunctionalTherapyApi";

export function get(sort?: "username" | "-username"): Promise<PatientWithAppointmentApi[]> {
  return get2<{ ordering?: "username" | "-username" }, PatientWithAppointmentApi[]>(
    "v1.0/patients",
    sort ? { ordering: sort } : undefined
  );
}
